import {
  Syringe,
  Stethoscope,
  Scissors,
  Microscope,
  Siren,
  ShoppingBag,
} from "lucide-react";

export const CLINIC = {
  name: "MS Pet Hospital",
  tagline: "Compassionate care for your pets, any time you need us.",
  phoneDisplay: "0336 7221320",
  phoneTel: "+923367221320",
  whatsapp: "https://wa.me/923367221320",
  open24: true,
  address: {
    line1: "Front of Jamia Mosque, Near Lignum Tower",
    line2: "Sector A, DHA Phase 2, Islamabad",
    full: "Front of Jamia Mosque, Near Lignum Tower, Sector A, DHA Phase 2, Islamabad",
  },
  hours: [{ day: "Every day of the week", time: "Open 24 Hours" }],
  mapEmbed:
    "https://www.google.com/maps?q=Lignum+Tower+DHA+Phase+2+Islamabad&output=embed",
  calendlyUrl: "https://calendly.com/kaifulwaraa1357/30min",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Approach", href: "#approach" },
  { label: "Team", href: "#team" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    icon: Siren,
    title: "Emergency Care",
    badge: "Open 24/7",
    desc: "A true round-the-clock emergency service. Whatever the hour, our team is ready — because pet emergencies don't wait for morning, and neither do we.",
    featured: true,
  },
  {
    icon: Stethoscope,
    title: "Surgery",
    badge: "Expert hands",
    desc: "From routine spays and neuters to complex procedures, surgeries are performed with care, modern equipment and gentle post-operative support for a smooth recovery.",
    featured: true,
  },
  {
    icon: Syringe,
    title: "Vaccinations",
    desc: "Keep your companion protected with timely core and lifestyle vaccinations, tailored to their age and needs.",
    featured: false,
  },
  {
    icon: Microscope,
    title: "Diagnostics",
    desc: "In-house testing and imaging for fast, accurate answers — so treatment can start without delay.",
    featured: false,
  },
  {
    icon: Scissors,
    title: "Grooming",
    desc: "Gentle, stress-free grooming that keeps your pet clean, comfortable and looking their very best.",
    featured: false,
  },
  {
    icon: ShoppingBag,
    title: "Pet Food & Supplies",
    desc: "Quality food, accessories and everyday essentials for cats, dogs and birds — all under one roof.",
    featured: false,
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "The Welcome",
    body: "Your pet is family — and we treat them that way from the moment you walk in. Calm hands, kind voices, and a space designed to keep anxious paws at ease.",
  },
  {
    no: "02",
    title: "The Diagnosis",
    body: "We take the time to listen and explain. You'll understand exactly what's going on with your companion, what your options are, and what we'd recommend — no rushing, no confusion.",
  },
  {
    no: "03",
    title: "The Care",
    body: "Day or night, we're here. From gentle check-ups to round-the-clock emergencies, our doctors stay by your side and keep you updated every step of the way.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Our cat fell seriously ill well past midnight and MS Pet Hospital was the only place open. Dr. Sheriyar and his team stayed calm, explained everything clearly, and treated her with such gentleness. Being open 24/7 genuinely saved her life.",
    name: "Verified Pet Owner",
    source: "Google Review",
  },
  {
    quote:
      "The most caring vets we've been to in Islamabad. They handled our nervous dog so patiently and never made us feel rushed. Clean, professional and available whenever we've needed them — we won't take our pets anywhere else.",
    name: "Verified Pet Owner",
    source: "Google Review",
  },
  {
    quote:
      "From vaccinations to a late-night emergency, they've looked after both our cat and our parrot beautifully. Kind staff, fair treatment and a team that clearly loves animals. Highly recommended.",
    name: "Verified Pet Owner",
    source: "Google Review",
  },
];

export const FAQS = [
  {
    q: "Are you really open 24 hours?",
    a: "Yes — MS Pet Hospital is open 24 hours a day, 7 days a week, including emergencies. Walk-ins are welcome at any hour, though for non-urgent visits we recommend booking ahead so we can give you our full attention.",
    unconfirmed: false,
  },
  {
    q: "Which animals do you treat?",
    a: "We care for cats and dogs, as well as birds. If you're unsure whether we can help with your particular pet, give us a call on 0336 7221320 and we'll be happy to advise.",
    unconfirmed: false,
  },
  {
    q: "Do you offer emergency care after midnight, and how do payments work?",
    a: "Emergency care is available around the clock, including after midnight — just call ahead so our team is ready when you arrive. Accepted payment methods haven't been confirmed for this page yet, so please check with us directly before your visit.",
    unconfirmed: true,
  },
];

export const GALLERY = [
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_premium-smile-arc/artifacts/ph5e24t1_ms%20pet%201.JPG",
    alt: "MS Pet Hospital veterinarians gently examining a cat",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_premium-smile-arc/artifacts/z99ebkhc_mspet%202.JPG",
    alt: "A fluffy dog being cared for at MS Pet Hospital",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_premium-smile-arc/artifacts/d3rvbl4k_mspet8.JPG",
    alt: "MS Pet Hospital pet food and supplies section",
  },
];

export const HERO_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_premium-smile-arc/artifacts/gntfr0uc_mspet4.JPG";
